module.exports = __webpack_public_path__ + "static/media/repsol.c1cbc05c.jpg";